import { fullName, location, profile, emailUrl } from "./profile";
import { labels } from "./ui";

// Scene units, except angles ending in Deg and the renderer pixel ratio.
export const sceneConfig = {
	renderer: { antialias: true, alpha: true, maxPixelRatio: 3, clearAlpha: 0 },
	camera: {
		flatFraming: 13.5,
		expandedFraming: 17,
		near: 0.1,
		far: 150,
		distance: 44,
		flatElevationDeg: 90 - (0.0001 * 180) / Math.PI,
		expandedElevationDeg: (0.55 * 180) / Math.PI,
		expandedAzimuthDeg: (-0.38 * 180) / Math.PI,
		focusY: 6.1,
	},
	lighting: {
		color: "#ffffff",
		ambientIntensity: 1.8,
		directionalIntensity: 3.1,
		position: { x: -12, y: 30, z: 18 },
	},
	shadows: {
		enabled: true,
		mapSize: 2048,
		cameraExtent: 20,
		normalBias: 0.03,
		intensity: 0.3,
		groundOpacity: 0.1,
	},
	base: {
		width: 24,
		height: 0.9,
		depth: 24,
		roughness: 0.85,
		flatScaleY: 0.16,
		topOffset: 0.035,
	},
	ground: { size: 200, y: -1 },
	qr: { width: 28, tileHeight: 0.035, tileY: -0.018, roughness: 1 },
	sculpture: {
		roughness: 0.65,
		defaultDepthLayers: 3,
		voxelFillRatio: 0.96,
		letterSpacing: 1,
		hitboxPadding: 0.12,
		shuffleMultiplier: 137,
		shuffleOffset: 53,
	},
};

export interface SculptureRow {
	text: string;
	color: string;
	z: number;
	step: number;
	base: number;
	depthLayers?: number;
	href?: string;
	linkLabel?: string;
}

// Colors reference CSS custom properties, without the leading --.
export const sculptureRows: SculptureRow[] = [
	{ text: fullName, color: "scene-name", z: -1.8, step: 0.35, base: 12.7 },
	{ text: profile.role, color: "scene-role", z: -0.6, step: 0.32, base: 9.1 },
	{ text: location, color: "scene-location", z: 0.6, step: 0.29, base: 5.8 },
	{
		text: profile.email,
		href: emailUrl,
		linkLabel: labels.emailTooltip,
		color: "scene-email",
		z: 3,
		step: 0.26,
		depthLayers: 1,
		base: 3.3,
	},
];
